export enum CustomFormType {
    SinglePageCustom = 'singlePageCustom',
    SinglePageTemplate = 'singlePageTemplate',
    MultiPages = 'multiPages',
}
